import { useAppSelector } from "../../redux/hooks";

const useStoreType = () => {
  const appConfig = useAppSelector(({ appConfig }) => appConfig);
  return appConfig?.domainConfig?.storeBrandingType;
};

export default useStoreType;
